module.exports = __webpack_public_path__ + "img/cover-game-01.5b8be884.jpg";